import viewSubCategory from './viewSubCategory';
import eventsAndInvitationsSubCategory from './eventsAndInvitationsSubCategory';
import eventsFromEmailSubCategory from './eventsFromEmailSubCategory';
import sharedCalendarsSubCategory from './sharedCalendarsSubCategory';
import weatherSubCategory from './weatherSubCategory';
var calendarCategory = {
    key: 'calendar',
    titleStringKey: 'optionCategory_Calendar',
    icon: "Calendar" /* Calendar */,
    subcategories: [
        viewSubCategory,
        eventsAndInvitationsSubCategory,
        weatherSubCategory,
        eventsFromEmailSubCategory,
        sharedCalendarsSubCategory,
    ],
};
export default calendarCategory;
//# sourceMappingURL=category.js.map